<template>
  <div class="app-container">


    <div class="gap"></div>
    <div style="text-align: left; padding-left: 20px;">
      <!-- <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button> -->

    </div>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="描述" align="center" width="200" label-class-name='title' prop="showLabe" />
      <el-table-column label="介绍" align="center" label-class-name='title' prop="showTxt" />
      <!-- <el-table-column label="等级说明" align="center" label-class-name='title' prop="level_desc" /> -->
      <!-- <el-table-column label="关于小程序" align="center"  label-class-name='title' prop="about" /> -->
      <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
            @click="handleUpdate(scope.row)">修改</el-button>
          <!-- <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>


    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />
    <!-- 操作日志详细 -->
    <el-dialog title="客户信息" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="等级说明">
              <el-input placeholder="请输入限制次数" v-model="form.times">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="等级说明">
              <el-input type="textarea" :rows="30" placeholder="请输入内容" v-model="form.level_desc">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="小程序说明">
              <el-input type="textarea" :rows="30" placeholder="请输入内容" v-model="form.about">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否开启">
              <el-select style="width: 100%;" v-model="form.status" placeholder="请选择">
                <el-option v-for="item in stateOptions" :key="item.prod_type" :label="item.label"
                  :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公告内容">
              <el-input   type="textarea"
              :rows="6"  v-model="form.content" placeholder="公告内容" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>



</template>

<script>
import config from '../../config/config'
import { recordList, qukuAdd, qukuList, qukuDelete, qukuUpdate } from '../api/quku/index';
import { userList, userUpdate, introList, introUpdate } from '../api/user/user';

import { Notification, MessageBox, Message, Link } from "element-ui";
export default {
  name: 'Operlog',
  data () {
    return {
      fileList: [],
      limit: 2,
      baseURL: '',  //  图片上传地址
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      intro: [
        { prod_type: 'C', label: 'C调' },
        { prod_type: 'D', label: 'D调' },
        { prod_type: 'E', label: 'E调' },
        { prod_type: 'F', label: 'F调' },
        { prod_type: 'G', label: 'G调' },
        { prod_type: 'A', label: 'A调' },
        { prod_type: 'bB', label: 'bB调' },
        { prod_type: 'B', label: 'B调' },
        { prod_type: 'bD', label: 'bD调' },
        { prod_type: 'bE', label: 'bE调' },
        { prod_type: 'bG', label: 'bG调' },
        { prod_type: 'bA', label: 'bA调' },
      ],
      levelList: [
        { prod_type: '1', label: '一级' },
        { prod_type: '2', label: '二级' },
        { prod_type: '3', label: '三级' },
      ],
      stateOptions: [
        { prod_type: '1', label: '启用' },
        { prod_type: '0', label: '停用' },
      ],
      options: [
        { prod_type: '0', label: '专业考级' },
        { prod_type: '1', label: '经典老歌' },
        { prod_type: '2', label: '网络流行' },
        { prod_type: '3', label: '草原情怀' },
        { prod_type: '4', label: '古风雅韵' },
        { prod_type: '5', label: '红歌精选' },
        { prod_type: '6', label: '影视金曲' },
        { prod_type: '7', label: '西北风情' },
        { prod_type: '8', label: '国外歌曲' },
        { prod_type: '9', label: '其他类型' },
      ],

      list: [],
      form: {
        qumu_name: '',
        qumu_qufeng: '0',
        qumu_pic: '',
        qumu_365_show: '1',
        qumu_state: '1',
        qumu_mark: '',
        qumu_banzou: '',
        qumu_shuoming: '',
        qumu_zhifa: '',
      },
      open: false,
      pageIndex: 1,
      pageSize: 10,
      // 禁用状态
      disabled: false,
      queryParams: {

      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total: 0,

    }
  },

  created () {
    this.handleQuery();
  },
  methods: {
    handleAvatarSuccess (res, file) {
      console.log(this.fileList)
      this.fileList.push(file)
      console.log(this.fileList)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
      console.log(this.fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload (file) {
      console.log(file);
    },
    handleUpdate (row) {
      
      this.open = true;
      this.form = {
        times: row.times,
        level_desc: row.level_desc,
        about: row.about,
        intro_id: row.intro_id,
        status: row.status,
        content: row.content,
      }
    },
    handleDelete (row) {
      let params = {
        id: row.id,
      }

      this.$confirm('确认删除吗？')
        .then(() => {
          qukuDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => { });

    },
    submit () {
      
      introUpdate(this.form).then(res => {
        this.$message.success('修改成功')
        console.log(res)
        this.open = false
        this.handleQuery()
      })
    },
    // 曲调
    transLevel (row) {
      let list = this.levelList
      for (let i = 0; i < list.length; i++) {
        if (list[i].prod_type == row.vip) {
          return list[i].label
        }
      }
    },

    //  退出
    logout () {
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.form = {
        qumu_name: '',
        qumu_qufeng: '0',
        qumu_pic: '',
        qumu_365_show: '1',
        qumu_state: '1',
        qumu_mark: '',
        qumu_banzou: '',
        qumu_shuoming: '',
        qumu_zhifa: '',
      }
    },
    // 查询按钮
    handleQuery () {
      this.list = []
      introList({}).then(res => {
        let list = res.data.list;
        let _list = [];




        _list.push({
          showLabe: '普通成员浏览次数限制',
          showTxt: list[0].times,
          intro_id: list[0].intro_id,
          times: list[0].times,
          level_desc: list[0].level_desc,
          about: list[0].about,
          content: list[0].content,
          status: list[0].status,
          statusShow: list[0].status=='1'?'启用':'停用',
        })
        _list.push({
          showLabe: '等级说明',
          showTxt: list[0].level_desc,
          intro_id: list[0].intro_id,
          times: list[0].times,
          level_desc: list[0].level_desc,
          about: list[0].about,
          content: list[0].content,
          status: list[0].status,
          statusShow: list[0].status=='1'?'启用':'停用',
        })
        _list.push({
          showLabe: '关于小程序',
          showTxt: list[0].about,
          intro_id: list[0].intro_id,
          times: list[0].times,
          level_desc: list[0].level_desc,
          about: list[0].about,
          content: list[0].content,
          status: list[0].status,
          statusShow: list[0].status=='1'?'启用':'停用',
        })
        _list.push({
          showLabe: '是否开启公告',
          showTxt: list[0].status=='1'?'启用':'停用',
          intro_id: list[0].intro_id,
          times: list[0].times,
          level_desc: list[0].level_desc,
          about: list[0].about,
          content: list[0].content,
          status: list[0].status,
        })
        _list.push({
          showLabe: '公告内容',
          showTxt: list[0].content,
          intro_id: list[0].intro_id,
          times: list[0].times,
          level_desc: list[0].level_desc,
          about: list[0].about,
          content: list[0].content,
          status: list[0].status,
          statusShow: list[0].status=='1'?'启用':'停用',
        })
        this.list = _list;
      })
    },

    //  上一页面
    preClick (e) {

      this.pageIndex = e;
      if (pageIndex <= 1) { return }
      this.handleQuery()
    },
    // 下一页
    preClick () {
      let pageIndex = this.pageIndex + 1;

      if (pageIndex * this.pageSize >= this.total) {
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      qukuList(params).then(res => {

        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.img {
  width: 50px;
  height: 50px;
  margin-left: 10px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px !important;
}

.el-upload--picture-card {
  width: 100px;
  height: 100px !important;
  line-height: 100;
}
</style>



// WEBPACK FOOTER //
// src/views/intro.vue